import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Box = styled.div`
  border-top: 1px solid ${({ theme }) => theme.palette.primary.border};
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
  background-color: ${({ theme }) => theme.palette.primary.background};
  margin-top: 10px;
`;

export const Title = styled(Typography.Header)`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px;
`;

export const Answer = styled.div`
  padding: 15px;

  > div * {
    font-family: Helvetica Neue, sans-serif;
    font-size: 15px;
    font-weight: 400;
  }

  > div > *:not(:last-child) {
    margin-bottom: 10px;
  }

  ul,
  ol {
    padding-left: 20px;
  }

  a {
    color: ${({ theme }) => theme.palette.system.blue};
  }
`;

export const Question = styled.section`
  border-top: 1px solid ${({ theme }) => theme.palette.primary.border};
`;

export const QuestionToggle = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  width: 100%;
  padding: 20px 15px;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.palette.primary.labels};
  font: inherit;
  text-align: left;
  cursor: pointer;

  svg {
    flex-shrink: 0;
  }

  &[aria-expanded='true'] {
    font-weight: 500;

    svg {
      transform: rotate(45deg);
    }
  }
`;

export const Loading = styled.div`
  display: grid;
  place-items: center;
  min-height: 240px;
`;
